
import React, { useState } from 'react';
import { Merchant, SampleRecord, MealType } from '../types';

interface RecordsViewProps {
  merchant: Merchant;
  records: SampleRecord[];
  onBack: () => void;
}

const RecordsView: React.FC<RecordsViewProps> = ({ merchant, records, onBack }) => {
  const [activeTab, setActiveTab] = useState<MealType>(MealType.Breakfast);

  const filteredRecords = records.filter(r => r.mealType === activeTab);

  return (
    <div className="flex flex-col h-full bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-slate-200">
      {/* Header Info */}
      <div className="bg-slate-50 px-10 py-8 border-b flex items-center justify-between">
        <div className="flex items-center space-x-10">
          <h2 className="text-4xl font-black text-blue-700 uppercase tracking-tight">{merchant.name}</h2>
          <div className="h-12 w-1 bg-slate-300 rounded-full"></div>
          <span className="text-2xl font-bold text-slate-500 tracking-wider">2026-01-16 留样历史记录</span>
        </div>
        <button 
          onClick={onBack}
          className="bg-slate-200 hover:bg-slate-300 text-slate-800 px-10 py-4 rounded-2xl font-black text-xl transition-all active:scale-95"
        >
          返回首页
        </button>
      </div>

      {/* Tabs */}
      <div className="flex p-3 bg-slate-100 m-6 rounded-3xl space-x-4 shadow-inner">
        {Object.values(MealType).map((type) => (
          <button
            key={type}
            onClick={() => setActiveTab(type)}
            className={`flex-1 py-5 px-8 rounded-2xl font-black text-xl transition-all ${
              activeTab === type 
                ? 'bg-white text-blue-700 shadow-xl' 
                : 'text-slate-500 hover:bg-slate-200/50'
            }`}
          >
            {type}
          </button>
        ))}
      </div>

      {/* Table - 隐藏滚动条 */}
      <div className="flex-1 overflow-y-auto px-10 pb-10 no-scrollbar">
        <table className="w-full text-left">
          <thead className="sticky top-0 bg-white z-10">
            <tr className="border-b-2 border-slate-100 text-slate-400 font-black text-lg uppercase tracking-widest">
              <th className="py-6 px-4">菜品名称</th>
              <th className="py-6 px-4">留样重量</th>
              <th className="py-6 px-4">留样时间</th>
              <th className="py-6 px-4">有效期至</th>
              <th className="py-6 px-4">留样人</th>
              <th className="py-6 px-4 text-center">留样照片</th>
              <th className="py-6 px-4 text-right">管理操作</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {filteredRecords.length > 0 ? (
              filteredRecords.map((r) => (
                <tr key={r.id} className="hover:bg-blue-50/30 transition-colors group">
                  <td className="py-6 px-4 font-black text-2xl text-slate-800">{r.dishName}</td>
                  <td className="py-6 px-4 text-blue-600 font-mono text-2xl font-bold">{r.weight}g</td>
                  <td className="py-6 px-4 text-slate-500 text-lg font-medium">{r.samplingTime}</td>
                  <td className="py-6 px-4 text-red-400 text-lg font-bold">{r.expiryTime}</td>
                  <td className="py-6 px-4 text-slate-700 font-bold text-xl">{r.sampler}</td>
                  <td className="py-6 px-4">
                    <div className="flex justify-center">
                       <img src={r.photoUrl} alt={r.dishName} className="w-20 h-20 rounded-2xl object-cover shadow-md group-hover:scale-110 transition-transform ring-4 ring-white" />
                    </div>
                  </td>
                  <td className="py-6 px-4 text-right">
                    <button className="text-blue-600 hover:text-blue-800 font-black text-xl bg-blue-50 px-6 py-2 rounded-xl transition-all">详情</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="py-32 text-center text-slate-300 italic text-2xl font-medium">
                  该餐别暂无留样数据
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecordsView;
